<template>
  <modal
    id="modal-calc"
    class="modal-calc"
    name="modal-calc"
    :draggable="isMobile() ? false : '.modal-header'"
    width="600"
    height="auto"
    v-show="showModalCalc"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Kalkulator inwestycyjny</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          @click="showModalCalc=false;"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="calc-download">
          <a href="#" v-tooltip.auto="$t('calc.pdf')" @click.prevent="downloadPdfList">
            <img src="img/pdf.png" />
          </a>
          <a href="#" v-tooltip.auto="$t('calc.xls')" @click.prevent="downloadXlsxList">
            <img src="img/xls.png" />
          </a>
        </div>
        <div class="modal-calc-vuebar" v-bar>
          <div>
            <table class="table">
              <thead>
                <tr>
                  <th colspan="2" class="table-head">{{ $t("calc.label1") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ $t("calc.criteria") }}</td>
                  <td>
                    <multiselect
                      class="map-printing-select"
                      v-model="InvestmentCriteriaCurrencySelected"
                      :options="InvestmentCriteriaCurrency"
                      :searchable="false"
                      :close-on-select="true"
                      :show-labels="false"
                      label="name"
                      v-bind:placeholder="this.$t('search.placeholder')"
                      open-direction="bottom"
                      track-by="name"
                    ></multiselect>
                  </td>
                </tr>

                <tr>
                  <td>{{ $t("calc.district") }}</td>
                  <td>{{ properties.powiat_nazwa }}</td>
                </tr>

                <tr>
                  <td>{{ $t("calc.community") }}</td>
                  <td>{{ properties.gmina_nazwa | removeCommunityName}}</td>
                </tr>

                <tr>
                  <td>{{ $t("calc.area") }}</td>
                  <td>{{ properties.nazwa | showInLang(currlang) }}</td>
                </tr>

                <tr>
                  <td>{{ $t("calc.size") }}</td>
                  <td>
                    <multiselect
                      v-model="InvestmentCriteriaSizeSelected"
                      :options="InvestmentCriteriaSize"
                      :searchable="false"
                      :close-on-select="true"
                      :show-labels="false"
                      label="name"
                      v-bind:placeholder="this.$t('search.placeholder')"
                      open-direction="bottom"
                      track-by="name"
                    ></multiselect>
                  </td>
                </tr>

                <tr>
                  <td>{{ $t("calc.tax") }}</td>
                  <td>
                    <input v-model="tax" type="number" step="0.01" />
                  </td>
                </tr>

                <tr>
                  <td>{{ $t("calc.sector") }}</td>
                  <td>
                    <multiselect
                      class="map-printing-select"
                      v-model="InvestmentCriteriaSectorSelected"
                      :options="InvestmentCriteriaSector"
                      :searchable="false"
                      :close-on-select="true"
                      :show-labels="false"
                      label="name"
                      v-bind:placeholder="this.$t('search.placeholder')"
                      open-direction="bottom"
                      track-by="name"
                    ></multiselect>
                  </td>
                </tr>

                <tr>
                  <td>{{ $t("calc.expenditures") }}</td>
                  <td>
                    <input v-model="expenditures" type="number" />
                  </td>
                </tr>

                <tr>
                  <td>{{ $t("calc.unemployment") }}</td>
                  <td>{{ InvestmentCriteriaURD }}</td>
                </tr>

                <tr>
                  <td>{{ $t("calc.ieeEUR") }}</td>
                  <td>{{ InvestmentCriteriaIEEEURValue }}</td>
                </tr>

                <tr>
                  <td>{{ $t("calc.ieePLN") }}</td>
                  <td>{{ InvestmentCriteriaIEEPLNValue }}</td>
                </tr>

                <tr>
                  <td>{{ $t("calc.ieeUSD") }}</td>
                  <td>{{ InvestmentCriteriaIEEUSDValue }}</td>
                </tr>
              </tbody>
            </table>

            <table class="table" v-show="showPublicAidDecisions">
              <thead>
                <tr>
                  <th colspan="2" class="table-head">{{ $t("calc.label2") }}</th>
                </tr>
              </thead>
              <tbody ref="publicAidDecisions">
                <tr>
                  <td>{{ $t("calc.intensity") }}</td>
                  <td>{{ PublicAidIntensityValue }}</td>
                </tr>
                <tr>
                  <td>{{ $t("calc.bigproject") }}</td>
                  <td>{{ PublicAidLargeProjectSelected }}</td>
                </tr>
                <tr>
                  <td>{{ $t("calc.maxHelpValue") }}</td>
                  <td>{{ PublicAidMaxHelpValue }}</td>
                </tr>
                <tr>
                  <td>{{ $t("calc.income") }}</td>
                  <td>{{ PublicAidTaxValValue.name }}</td>
                </tr>
              </tbody>
            </table>
            <table class="table" v-show="showPublicAidDecisions">
              <thead>
                <tr>
                  <th colspan="2" class="table-head">{{ $t('calc.decisions') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ $t("calc.status") }}</td>
                  <td>{{ EntrepreneurDecisionsSEZSelected }}</td>
                </tr>
                <tr>
                  <td>{{ $t("calc.term") }}</td>
                  <td>{{ EntrepreneurDecisionsValidityValue }}</td>
                </tr>
                <tr>
                  <td>{{ $t("calc.criterion") }}</td>
                  <td>{{ EntrepreneurDecisionsMQQSelected }}</td>
                </tr>
                <tr>
                  <td>{{ $t("calc.mwn") }}</td>
                  <td>{{ EntrepreneurDecisionsMinExp }}</td>
                </tr>
                <tr>
                  <td>{{ $t("calc.loses") }}</td>
                  <td>{{ GminaTraciFunkcje }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-calc-footer">
          <div class="button-col">
            <b-button @click="postNow();" variant="primary">{{ $t("calc.calculate") }}</b-button>
          </div>
          <div class="add-col">
            {{ $t("calc.add1") }}
            <br />
            <br />
            {{ $t("calc.add2") }}
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Multiselect from "vue-multiselect";
import XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "../../DejaVuSans-normal";

function GenInvestmentCriteriaIEEXXXValue(WALUTA) {
  return function() {
    if (this.kursy[WALUTA]) {
      return ((this.expenditures * this.kursXXX) / this.kursy[WALUTA]).toFixed(
        2
      );
    } else {
      return "-";
    }
  };
}

export default {
  components: {
    Multiselect
  },
  data() {
    return {
      expenditures: 0,
      tax: 0.19,

      InvestmentCriteriaSizeSelected: {
        name: this.$t("calc.big"),
        value: "duze"
      },
      InvestmentCriteriaSize: [
        { name: this.$t("calc.big"), value: "duze" },
        { name: this.$t("calc.medium"), value: "srednie" },
        { name: this.$t("calc.small"), value: "male" },
        { name: this.$t("calc.micro"), value: "mikro" }
      ],

      InvestmentCriteriaSectorSelected: {
        name: this.$t("calc.industry"),
        value: "przemysl"
      },
      InvestmentCriteriaSector: [
        { name: this.$t("calc.industry"), value: "przemysl" },
        { name: this.$t("calc.services"), value: "uslugi" }
      ],

      InvestmentCriteriaCurrencySelected: { name: "PLN", value: "PLN" },
      InvestmentCriteriaCurrency: [
        { name: "PLN", value: "PLN" },
        { name: "EUR", value: "EUR" },
        { name: "USD", value: "USD" }
      ],

      EntrepreneurDecisionsSEZSelected: this.$t("calc.yes"),
      EntrepreneurDecisionsSEZ: [this.$t("calc.yes"), this.$t("calc.no")],
      EntrepreneurDecisionsValidityValue: "",
      EntrepreneurDecisionsMQQSelected: "",
      EntrepreneurDecisionsMQQ: [this.$t("calc.yes"), this.$t("calc.no")],

      EntrepreneurDecisionsRealHelpValue: "",
      EntrepreneurDecisionsMinExp: "",

      PublicAidIntensityValue: "",
      PublicAidLargeProjectSelected: this.$t("calc.yes"),
      PublicAidLargeProject: [this.$t("calc.yes"), this.$t("calc.no")],
      PublicAidLargeProjectValEURValue: "6 000" + this.$t("calc.eur"),
      PublicAidLargeProjectValPLNValue: "24 000" + this.$t("calc.pln"),
      PublicAidMaxHelpValue: "",

      PublicAidTaxValValue: {},

      kursy: {},

      showPublicAidDecisions: false,

      GminaTraciFunkcje: "-",
    };
  },
  computed: {
    kursXXX() {
      return this.kursy[this.InvestmentCriteriaCurrencySelected.value];
    },
    InvestmentCriteriaIEEEURValue: GenInvestmentCriteriaIEEXXXValue("EUR"),
    InvestmentCriteriaIEEPLNValue: GenInvestmentCriteriaIEEXXXValue("PLN"),
    InvestmentCriteriaIEEUSDValue: GenInvestmentCriteriaIEEXXXValue("USD"),
    objeta_sse_available() {
      return this.$store.getters.listType == "tereny";
    },
    objeta_sse() {
      return this.properties.objeta_sse;
    },
    objeta_sse_translated() {
      return this.$t((this.objeta_sse && "calc.yes") || "calc.no");
    },
    currlang() {
      return this.$parent.currlang;
    },
    properties() {
      let item = this.$store.getters.currentItem;
      return (item && item.properties) || {};
    },
    showModalCalc: {
      get() {
        return this.$parent.showModalCalc;
      },
      set() {
        this.$parent.showModalCalc = false;
      }
    },
    InvestmentCriteriaURD() {
      let powiat = this.$store.getters["jst/powiatById"](
        this.properties.powiat_id
      );
      return powiat && powiat.stopa_bezrobocia;
    },
    communityId() {
      return this.properties.gmina_id;
    }
  },
  watch: {
    objeta_sse: {
      immediate: true,
      handler() {
        this.EntrepreneurDecisionsSEZSelected = this.objeta_sse_translated;
      }
    },
    currlang() {
      this.updateModal();
    },
    showModalCalc(newV, oldV) {
      if (newV != oldV) {
        this.showPublicAidDecisions = false;
      }
    }
  },
  methods: {
    getListTable() {
      let rows = [
        [this.$t("calc.label1"), ""],
        [
          this.$t("calc.criteria"),
          this.InvestmentCriteriaCurrencySelected.name
        ],
        [this.$t("calc.district"), this.properties.powiat_nazwa],
        [
          this.$t("calc.community"),
          this.$options.filters.removeCommunityName(this.properties.gmina_nazwa)
        ],
        [
          this.$t("calc.area"),
          this.$options.filters.showInLang(this.properties.nazwa, this.currlang)
        ],
        [this.$t("calc.size"), this.InvestmentCriteriaSizeSelected.name],
        [this.$t("calc.tax"), this.tax],
        [this.$t("calc.sector"), this.InvestmentCriteriaSectorSelected.name],
        [this.$t("calc.expenditures"), this.expenditures],
        [this.$t("calc.unemployment"), this.InvestmentCriteriaURD],
        [this.$t("calc.ieeEUR"), this.InvestmentCriteriaIEEEURValue],
        [this.$t("calc.ieePLN"), this.InvestmentCriteriaIEEPLNValue],
        [this.$t("calc.ieeUSD"), this.InvestmentCriteriaIEEUSDValue]
      ];

      let rows2 = [
        ["", ""],
        [this.$t("calc.label2"), ""],
        [this.$t("calc.intensity"), this.PublicAidIntensityValue],
        [this.$t("calc.bigproject"), this.PublicAidLargeProjectSelected],
        [this.$t("calc.realhelp"), this.EntrepreneurDecisionsRealHelpValue],
        [this.$t("calc.maxHelpValue"), this.PublicAidMaxHelpValue],
        [this.$t("calc.income"), this.PublicAidTaxValValue.name],

        ["", ""],
        [this.$t("calc.decisions"), ""],
        [this.$t("calc.status"), this.EntrepreneurDecisionsSEZSelected],
        [this.$t("calc.term"), this.EntrepreneurDecisionsValidityValue],
        [this.$t("calc.criterion"), this.EntrepreneurDecisionsMQQSelected],
        [this.$t("calc.mwn"), this.EntrepreneurDecisionsMinExp],
        [this.$t("calc.loses"), this.GminaTraciFunkcje],
      ];

      if (this.showPublicAidDecisions) {
        rows = rows.concat(rows2);
      }

      return {
        headings: ["", ""],
        rows,
        xlsxCols: [
          {
            width: 60
          },
          {
            width: 20
          }
        ]
      };
    },
    downloadPdfList() {
      this.downloadPdfTable({
        table: this.getListTable(),
        filename: "calc.pdf"
      });
    },
    downloadXlsxList() {
      this.downloadXlsxTable({
        table: this.getListTable(),
        filename: "calc.xlsx"
      });
    },
    downloadPdfTable({ table, filename }) {
      let { headings, rows } = table;
      let doc = new jsPDF();
      doc.autoTable({
        head: [headings],
        body: rows,
        styles: {
          font: "DejaVuSans",
          fontStyle: "normal"
        }
      });
      doc.save(filename);
    },
    downloadXlsxTable({ table, filename, xlsxCols }) {
      let { headings, rows } = table;
      let aoa = [headings].concat(rows);
      let ws = XLSX.utils.aoa_to_sheet(aoa);
      ws["!cols"] = xlsxCols || table.xlsxCols;
      let wb = {
        SheetNames: ["Sheet"],
        Sheets: {
          Sheet: ws
        }
      };
      XLSX.writeFile(wb, filename);
    },
    updateModal() {
      this.$set(
        this.InvestmentCriteriaSectorSelected,
        "name",
        this.$t("calc.industry")
      );
      this.$set(this.InvestmentCriteriaSector, 0, {
        name: this.$t("calc.industry"),
        value: "przemysl"
      });
      this.$set(this.InvestmentCriteriaSector, 1, {
        name: this.$t("calc.services"),
        value: "uslugi"
      });

      this.$set(
        this.InvestmentCriteriaSizeSelected,
        "name",
        this.$t("calc.big")
      );

      this.$set(this.InvestmentCriteriaSector, 0, {
        name: this.$t("calc.big"),
        value: "duze"
      });

      this.$set(this.InvestmentCriteriaSector, 1, {
        name: this.$t("calc.medium"),
        value: "srednie"
      });

      this.$set(this.InvestmentCriteriaSector, 2, {
        name: this.$t("calc.small"),
        value: "male"
      });

      this.$set(this.InvestmentCriteriaSector, 3, {
        name: this.$t("calc.micro"),
        value: "mikro"
      });
    },
    postNow() {
      this.$http
        .post(
          "/kalkulator_pub/kalkulator",
          {
            gmina_id: this.communityId,
            naklady: this.expenditures,
            podatek: this.tax,
            sektor: this.InvestmentCriteriaSectorSelected.value,
            waluta: this.InvestmentCriteriaCurrencySelected.value,
            wielkosc_przedsiebiorstwa: this.InvestmentCriteriaSizeSelected
              .value,
            objeta_sse: this.objeta_sse,
            gmina_traci_funkcje: this.properties.gmina_traci_funkcje,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json"
            }
          }
        )
        .then(response => {
          this.showPublicAidDecisions = true;
          var data = response.data;
          this.kursy = data.kursy;
          this.EntrepreneurDecisionsMQQSelected = this.setYesOrNo(
            data.spelnione
          );
          this.EntrepreneurDecisionsValidityValue =
            data.data_wsparcia + " " + this.$t("calc.years");
          this.$set(
            this.PublicAidTaxValValue,
            "name",
            Number(data.dochod_zwolniony) +
              this.InvestmentCriteriaCurrencySelected.name
          );
          this.PublicAidLargeProjectSelected = this.setYesOrNo(
            data.duzy_projekt
          );
          this.PublicAidIntensityValue = Math.round(data.intensywnosc_pomocy * 100) + "%";
          this.PublicAidMaxHelpValue =
            data.pomoc_maksymalna +
            this.InvestmentCriteriaCurrencySelected.name;
          this.EntrepreneurDecisionsMinExp =
            data.naklady_wymog +
            " " +
            this.InvestmentCriteriaCurrencySelected.name;

          this.GminaTraciFunkcje = this.setYesOrNo(
                  data.gmina_traci_funkcje
          );
          setTimeout(
            () =>
              this.$refs.publicAidDecisions.scrollIntoView({
                behavior: "smooth"
              }),
            300
          );
        });
    },
    setYesOrNo(value) {
      return value ? this.$t("calc.yes") : this.$t("calc.no");
    }
  }
};
</script>
